import { Button } from '@/components/ui-kit/button';
import { LayoutGrid, ListOrdered } from 'lucide-react';
import { parseAsString, useQueryStates } from 'nuqs';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui-kit/tabs';
import { AgentsList } from './agents-list';
import { AddAgent } from '@/modules/gpt-chats/components/add-agent';
import { useTranslation } from 'react-i18next';
import { useIsProtected } from '@/state/store/auth/use-is-protected';
import { useGetAgents } from '@/modules/gpt-chats/hooks/use-agents';
import { AGENTS_LIMIT } from '@/modules/gpt-chats/constants';

const projectKey = import.meta.env.VITE_X_BLOCKS_KEY || '';

export const Agents = () => {
  const { t } = useTranslation();
  const { isProtected: userHasAdminRole } = useIsProtected({ roles: ['admin'] });
  const [queries, setQueries] = useQueryStates({
    view: parseAsString.withDefault('grid'),
  });

  const { data, isLoading } = useGetAgents({
    limit: AGENTS_LIMIT,
    offset: 0,
    project_key: projectKey,
  });

  const totalCount = data?.total_count || 0;
  const showAddAgentHeader = userHasAdminRole && totalCount > 0 && totalCount < AGENTS_LIMIT;

  return (
    <>
      <section className="flex flex-col gap-6">
        <div className="flex min-h-10 items-center justify-between">
          <h3 className="text-2xl font-bold tracking-tight">{t('AGENTS')}</h3>

          <div className="flex items-center gap-4">
            {showAddAgentHeader && (
              <div className="mt-[-16px]">
                <AddAgent />
              </div>
            )}

            <Tabs
              value={queries.view}
              onValueChange={(v) => setQueries({ view: v as 'grid' | 'list' })}
              className="hidden sm:block"
            >
              <TabsList>
                <TabsTrigger value="list">
                  <ListOrdered className="aspect-square w-4" />
                </TabsTrigger>
                <TabsTrigger value="grid">
                  <LayoutGrid className="aspect-square w-4" />
                </TabsTrigger>
              </TabsList>
            </Tabs>

            <Button
              variant="outline"
              size="sm"
              onClick={() => setQueries({ view: queries.view === 'list' ? 'grid' : 'list' })}
              className="sm:hidden"
            >
              {queries.view === 'list' ? (
                <LayoutGrid className="aspect-square w-4" />
              ) : (
                <ListOrdered className="aspect-square w-4" />
              )}
            </Button>
          </div>
        </div>

        <AgentsList view={queries.view as 'grid' | 'list'} data={data} isLoading={isLoading} />
      </section>
    </>
  );
};
